import API_CONSTANT from 'constants/apiConstant';
import { put, takeEvery } from 'redux-saga/effects';
import { triggerRateTransactionApiSuccess } from 'redux/actions';
import { TRIGGER_RATE_TRANSACTION_API } from 'redux/actionTypes';
import { apiCall } from 'services';

function* triggerRateTransactionApi(actions) {
	const { data } = actions;
	const rateInfo = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.POST_PE,
		url: API_CONSTANT.URL.APPRATE_TXN,
		method: 'POST',
		data,
		options: {
			defaultLoader: false,
			restrictToast: true,
		},
	});
	if (rateInfo && rateInfo.data.data) {
		const data = rateInfo.data.data;
		yield put(triggerRateTransactionApiSuccess(data));
	}
}

export default function* triggerRateTransactionApiSaga() {
	yield takeEvery(TRIGGER_RATE_TRANSACTION_API, triggerRateTransactionApi);
}
